import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationHistoryKey,
  applicationsCountsKey,
  employerApplicationsKey,
  enterpriseApplicationsKey,
  enterpriseBulkActionRoute,
  errorMessage,
  interviewCountsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { applicantDetailsKey } from '@features/applicant';
import { eventsInterviewKey } from '@features/enterpriseEvents';

type useEnterpriseBulkActionProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useEnterpriseBulkAction = ({ setErrorText }: useEnterpriseBulkActionProps) => {
  const client = useQueryClient();

  const {
    data: enterpriseBulkActionData,
    mutate: enterpriseCreateBulkAction,
    isLoading: isEnterpriseCreateBulkActionLoading,
    isSuccess: isEnterpriseCreateBulkActionSuccess,
    reset: resetEnterpriseCreateBulkAction,
  } = useMutation({
    mutationFn: (variables: {
      action: string | undefined;
      ids: string;
      message?: string;
    }) =>
      axiosInstance.post(enterpriseBulkActionRoute, variables).then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(enterpriseApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries(applicantDetailsKey);
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(eventsInterviewKey);
        client.invalidateQueries(interviewCountsKey);
        client.invalidateQueries(applicationHistoryKey);

        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });
  return {
    enterpriseBulkActionData,
    enterpriseCreateBulkAction,
    isEnterpriseCreateBulkActionLoading,
    isEnterpriseCreateBulkActionSuccess,
    resetEnterpriseCreateBulkAction,
  };
};
